import { Types } from "@grandvisionhq/graphql";
import { isDefined } from "@grandvisionhq/utils";
const getIsAvailableForSubscription = (variant) => {
  const priceList = variant.priceList || [];
  const hasAvailableForSubscriptionAttribute = variant.isAvailableForSubscription;
  const subscriptionPriceItem = priceList.find(
    (price) => price.priceType === Types.ProductPriceItemType.SUBSCRIPTION && isDefined(price.originalPrice)
  );
  if (hasAvailableForSubscriptionAttribute && !subscriptionPriceItem) {
    console.error(
      `Product is available for subscription, but has no subscription price. sku: ${variant.sku}, name: ${variant.displayName}`
    );
    return false;
  }
  return hasAvailableForSubscriptionAttribute && !!subscriptionPriceItem;
};
export {
  getIsAvailableForSubscription
};
//# sourceMappingURL=get-is-available-for-subscription.js.map
